import { defineComponent as _defineComponent } from 'vue'
import { createElementVNode as _createElementVNode, openBlock as _openBlock, createElementBlock as _createElementBlock, normalizeClass as _normalizeClass, toDisplayString as _toDisplayString, createTextVNode as _createTextVNode, withModifiers as _withModifiers, createCommentVNode as _createCommentVNode, createStaticVNode as _createStaticVNode, Fragment as _Fragment, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"
import _imports_0 from '@/assets/question.svg'


const _withScopeId = n => (_pushScopeId("data-v-27277c09"),n=n(),_popScopeId(),n)
const _hoisted_1 = { class: "bg-white rounded-xl flex flex-col justify-between w-full z-10 md:hidden" }
const _hoisted_2 = /*#__PURE__*/_createStaticVNode("<div class=\"text-xs text-white bg-secondary rounded-t-2xl flex justify-center items-center h-8\" data-v-27277c09><span id=\"statsMinDate2\" data-v-27277c09></span><span class=\"icon icon-calendar ml-1 mr-2\" data-v-27277c09></span><svg class=\"w-20\" viewBox=\"0 0 800 200\" xmlns=\"http://www.w3.org/2000/svg\" data-v-27277c09><circle cx=\"50\" cy=\"100\" r=\"30\" fill=\"white\" data-v-27277c09></circle><line x1=\"50\" y1=\"100\" x2=\"750\" y2=\"100\" stroke=\"white\" stroke-width=\"15\" data-v-27277c09></line><circle cx=\"750\" cy=\"100\" r=\"30\" fill=\"white\" data-v-27277c09></circle></svg><span id=\"statsMaxDate2\" class=\"ml-2\" data-v-27277c09></span><span class=\"icon icon-calendar ml-1\" data-v-27277c09></span></div>", 1)
const _hoisted_3 = {
  key: 0,
  id: "stats-content",
  class: "flex flex-row justify-around"
}
const _hoisted_4 = { class: "flex flex-col" }
const _hoisted_5 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("span", { class: "icon icon-rescue text-4xl leading-6 text-center text-secondary" }, null, -1))
const _hoisted_6 = { class: "text-sm text-main font-bold" }
const _hoisted_7 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("span", {
  id: "statsNbSurvivor2",
  class: "text-secondary text-lg"
}, null, -1))
const _hoisted_8 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("span", { class: "icon icon-sosmed-ship text-4xl leading-6 text-center text-secondary" }, null, -1))
const _hoisted_9 = { class: "text-sm text-center text-main font-bold" }
const _hoisted_10 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("span", {
  id: "statsOps2",
  class: "text-secondary text-lg"
}, null, -1))
const _hoisted_11 = { class: "bg-white rounded-xl flex-col justify-between position-desktop absolute hidden md:flex" }
const _hoisted_12 = /*#__PURE__*/_createStaticVNode("<h1 class=\"bg-secondary text-white text-center rounded-t mb-1\" data-v-27277c09><span id=\"statsMinDate\" data-v-27277c09></span> <span class=\"icon icon-calendar text-sm\" data-v-27277c09></span> - <span id=\"statsMaxDate\" data-v-27277c09></span><span class=\"icon icon-calendar text-sm ml-1\" data-v-27277c09></span></h1>", 1)
const _hoisted_13 = { class: "flex flex-col pb-3 pl-6 pr-6" }
const _hoisted_14 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("span", { class: "icon icon-rescue text-3xl text-center text-secondary" }, null, -1))
const _hoisted_15 = { class: "text-main text-xl font-bold mb-2 flex justify-center" }
const _hoisted_16 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("span", {
  id: "statsNbSurvivor",
  class: "text-secondary mr-2"
}, null, -1))
const _hoisted_17 = { class: "flex flex-row justify-around mb-2 text-main" }
const _hoisted_18 = { class: "flex flex-col" }
const _hoisted_19 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("span", { class: "icon icon-female text-4xl text-center" }, null, -1))
const _hoisted_20 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("span", {
  id: "statsFemale",
  class: "font-bold text-center"
}, null, -1))
const _hoisted_21 = { class: "text-xs uppercase text-center" }
const _hoisted_22 = { class: "flex flex-col" }
const _hoisted_23 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("span", { class: "icon icon-male text-4xl text-center" }, null, -1))
const _hoisted_24 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("span", {
  id: "statsMale",
  class: "font-bold text-center"
}, null, -1))
const _hoisted_25 = { class: "text-xs uppercase text-center" }
const _hoisted_26 = { class: "flex flex-col" }
const _hoisted_27 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("span", { class: "icon icon-kid text-4xl text-center" }, null, -1))
const _hoisted_28 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("span", {
  id: "statsMinor",
  class: "font-bold text-center"
}, null, -1))
const _hoisted_29 = { class: "text-xs uppercase text-center" }
const _hoisted_30 = { class: "flex flex-row justify-around border-dotted border-secondary border-2 rounded-xl p-4 mb-1" }
const _hoisted_31 = { class: "flex flex-row" }
const _hoisted_32 = { class: "flex flex-col" }
const _hoisted_33 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("span", {
  id: "statsPregnant",
  class: "font-bold text-right text-secondary"
}, null, -1))
const _hoisted_34 = { class: "text-3xs uppercase text-right text-secondary text-stats-box" }
const _hoisted_35 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("span", { class: "icon icon-pregnant text-4xl text-right text-secondary" }, null, -1))
const _hoisted_36 = { class: "flex flex-col" }
const _hoisted_37 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("span", { class: "icon text-4xl text-center text-secondary" }, null, -1))
const _hoisted_38 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("span", {
  id: "statsUnaccompagnied",
  class: "font-bold text-center text-secondary"
}, null, -1))
const _hoisted_39 = { class: "text-3xs uppercase text-center text-secondary text-stats-box" }
const _hoisted_40 = { class: "flex flex-row" }
const _hoisted_41 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("span", { class: "icon icon-bib text-3xl text-left text-secondary" }, null, -1))
const _hoisted_42 = { class: "flex flex-col" }
const _hoisted_43 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("span", {
  id: "statsChildren",
  class: "font-bold text-left text-secondary"
}, null, -1))
const _hoisted_44 = { class: "text-3xs uppercase text-left text-secondary text-stats-box" }
const _hoisted_45 = { class: "text-sm text-center text-secondary" }
const _hoisted_46 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("span", { class: "icon icon-planet mr-3" }, null, -1))
const _hoisted_47 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("span", { id: "statsNationalities" }, null, -1))
const _hoisted_48 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("hr", { class: "border w-1/4 ml-auto mr-auto mt-2 mb-2" }, null, -1))
const _hoisted_49 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("span", { class: "icon icon-tour text-8xl leading-6 text-center text-secondary mb-2" }, null, -1))
const _hoisted_50 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("span", { class: "icon icon-sosmed-ship text-8xl leading-6 text-center text-secondary mb-2" }, null, -1))
const _hoisted_51 = { class: "text-center text-main text-xl font-bold flex justify-center" }
const _hoisted_52 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("span", {
  id: "statsOps3",
  class: "text-secondary mr-2"
}, null, -1))

import { store } from "@/main"
import { ref } from "vue"

export default /*#__PURE__*/_defineComponent({
  __name: 'Stats',
  setup(__props) {

const displayingStats = ref(true)
function showVirtualVisit (): void {
  store.switchVirtualVisitVisibility()
}

function setInformationTooltip (event: MouseEvent, title: string, text: string) {
  store.setInformationTooltipParameters(true, { orientation: "right", x: event.clientX, y: event.clientY }, { title, text })
}
function removeInformationTooltip () {
  store.setInformationTooltipParameters(false)
}

return (_ctx: any,_cache: any) => {
  return (_openBlock(), _createElementBlock(_Fragment, null, [
    _createElementVNode("div", _hoisted_1, [
      _hoisted_2,
      _createElementVNode("div", {
        id: "displaying-button",
        class: _normalizeClass(["text-center icon flex-0 mr-2 cursor-pointer", { 'icon-help-circle': !displayingStats.value, 'icon-camera': displayingStats.value }]),
        onClick: _cache[0] || (_cache[0] = ($event: any) => (displayingStats.value = !displayingStats.value))
      }, null, 2),
      (displayingStats.value)
        ? (_openBlock(), _createElementBlock("div", _hoisted_3, [
            _createElementVNode("div", _hoisted_4, [
              _hoisted_5,
              _createElementVNode("p", _hoisted_6, [
                _hoisted_7,
                _createTextVNode(" " + _toDisplayString(_ctx.$t("stats.peoples")), 1)
              ])
            ]),
            _createElementVNode("div", {
              class: "flex flex-col cursor-pointer virtual-visit-shower",
              onClick: _cache[1] || (_cache[1] = _withModifiers(($event: any) => (showVirtualVisit()), ["stop"]))
            }, [
              _hoisted_8,
              _createElementVNode("p", _hoisted_9, [
                _hoisted_10,
                _createTextVNode(" " + _toDisplayString(_ctx.$t("stats.rescueNb")), 1)
              ])
            ])
          ]))
        : _createCommentVNode("", true)
    ]),
    _createElementVNode("div", _hoisted_11, [
      _hoisted_12,
      _createElementVNode("div", _hoisted_13, [
        _hoisted_14,
        _createElementVNode("p", _hoisted_15, [
          _hoisted_16,
          _createTextVNode(" " + _toDisplayString(_ctx.$t("stats.peoples")) + " ", 1),
          _createElementVNode("img", {
            class: "more-information-button ml-2",
            src: _imports_0,
            alt: "",
            onMouseenter: _cache[2] || (_cache[2] = ($event: any) => (setInformationTooltip($event, _ctx.$t('stats.peoples'), _ctx.$t('stats.peoplesDescription')))),
            onMouseleave: removeInformationTooltip
          }, null, 32)
        ]),
        _createElementVNode("div", _hoisted_17, [
          _createElementVNode("div", _hoisted_18, [
            _hoisted_19,
            _hoisted_20,
            _createElementVNode("p", _hoisted_21, _toDisplayString(_ctx.$t("stats.females")), 1)
          ]),
          _createElementVNode("div", _hoisted_22, [
            _hoisted_23,
            _hoisted_24,
            _createElementVNode("p", _hoisted_25, _toDisplayString(_ctx.$t("stats.males")), 1)
          ]),
          _createElementVNode("div", _hoisted_26, [
            _hoisted_27,
            _hoisted_28,
            _createElementVNode("p", _hoisted_29, _toDisplayString(_ctx.$t("stats.minors")), 1)
          ])
        ]),
        _createElementVNode("div", _hoisted_30, [
          _createElementVNode("div", _hoisted_31, [
            _createElementVNode("div", _hoisted_32, [
              _hoisted_33,
              _createElementVNode("p", _hoisted_34, _toDisplayString(_ctx.$t("stats.pregnants")), 1)
            ]),
            _hoisted_35
          ]),
          _createElementVNode("div", _hoisted_36, [
            _hoisted_37,
            _hoisted_38,
            _createElementVNode("p", _hoisted_39, _toDisplayString(_ctx.$t("stats.unaccompanied")), 1)
          ]),
          _createElementVNode("div", _hoisted_40, [
            _hoisted_41,
            _createElementVNode("div", _hoisted_42, [
              _hoisted_43,
              _createElementVNode("p", _hoisted_44, _toDisplayString(_ctx.$t("stats.children")), 1)
            ])
          ])
        ]),
        _createElementVNode("p", _hoisted_45, [
          _hoisted_46,
          _hoisted_47,
          _createTextVNode(" " + _toDisplayString(_ctx.$t("stats.nationalities")), 1)
        ]),
        _hoisted_48,
        _createElementVNode("div", {
          class: "flex flex-col flex-wrap align-center cursor-pointer virtual-visit-shower",
          onClick: _cache[4] || (_cache[4] = _withModifiers(($event: any) => (showVirtualVisit()), ["stop"]))
        }, [
          _hoisted_49,
          _hoisted_50,
          _createElementVNode("p", _hoisted_51, [
            _hoisted_52,
            _createTextVNode(" " + _toDisplayString(_ctx.$t("stats.rescueNb")) + " ", 1),
            _createElementVNode("img", {
              class: "more-information-button ml-2",
              src: _imports_0,
              alt: "",
              onMouseenter: _cache[3] || (_cache[3] = ($event: any) => (setInformationTooltip($event, _ctx.$t('stats.rescueNb'), _ctx.$t('stats.rescueDescription')))),
              onMouseleave: removeInformationTooltip
            }, null, 32)
          ])
        ])
      ])
    ])
  ], 64))
}
}

})